import { render, staticRenderFns } from "./enLayout.vue?vue&type=template&id=50fbff3c&"
import script from "./enLayout.vue?vue&type=script&lang=js&"
export * from "./enLayout.vue?vue&type=script&lang=js&"
import style0 from "./enLayout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports